const OPENSOLAR_SCRIPT_ID = "opensolar_lead_capture_dynamic";
const OPENSOLAR_SRC = "https://api.opensolar.com/api/lead_capture_widget/4e683fcece0d4faf80e305ebf975784a";

export function openOpenSolar(prefilledComments?: string) {
  const w = window as any;

  const invoke = () => {
    try {
      w.renderOpenSolarWidget?.();
      
      // If we have prefilled comments, try multiple strategies to inject them
      if (prefilledComments) {
        // Strategy 1: Try immediately after widget render
        setTimeout(() => {
          injectComments(prefilledComments);
        }, 500);
        
        // Strategy 2: Try again after a longer delay (for slow loading)
        setTimeout(() => {
          injectComments(prefilledComments);
        }, 2000);
        
        // Strategy 3: Monitor for iframe loads and try injection
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && (node as HTMLElement).tagName === 'IFRAME') {
                setTimeout(() => injectComments(prefilledComments), 1000);
              }
            });
          });
        });
        
        observer.observe(document.body, { childList: true, subtree: true });
        
        // Clean up observer after 10 seconds
        setTimeout(() => observer.disconnect(), 10000);
      }
    } catch (_) {
      // ignore
    }
  };

  const injectComments = (comments: string) => {
    // Try multiple selectors for the comments/opmerkingen field
    const selectors = [
      'textarea[placeholder*="comments" i]',
      'textarea[placeholder*="opmerkingen" i]',
      'textarea[name*="comments" i]',
      'textarea[name*="opmerkingen" i]',
      'textarea[id*="comments" i]',
      'textarea[id*="opmerkingen" i]',
      'textarea[placeholder*="additional" i]',
      'textarea[placeholder*="extra" i]',
      'iframe textarea', // If widget is in iframe
      '#opensolar-widget textarea',
      '[class*="opensolar"] textarea',
      'textarea:last-of-type' // Last textarea on page (often comments)
    ];

    let injected = false;
    
    for (const selector of selectors) {
      try {
        const field = document.querySelector(selector) as HTMLTextAreaElement;
        if (field && !injected) {
          field.value = comments;
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('✅ Successfully injected calculator data into OpenSolar widget');
          injected = true;
          break;
        }
      } catch (e) {
        // Continue to next selector
      }
    }
    
    // If we can't find the field directly, try accessing iframe content
    if (!injected) {
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
          if (iframeDoc) {
            const textarea = iframeDoc.querySelector('textarea') as HTMLTextAreaElement;
            if (textarea) {
              textarea.value = comments;
              textarea.dispatchEvent(new Event('input', { bubbles: true }));
              console.log('✅ Successfully injected calculator data into OpenSolar iframe');
              injected = true;
            }
          }
        } catch (e) {
          // Cross-origin restrictions - can't access iframe content
        }
      });
    }
    
    if (!injected) {
      console.log('⚠️ Could not inject calculator data - comments field not found');
    }
  };

  // Already available
  if (typeof w.renderOpenSolarWidget === "function") {
    invoke();
    return;
  }

  // Load script once
  if (!document.getElementById(OPENSOLAR_SCRIPT_ID)) {
    const s = document.createElement("script");
    s.id = OPENSOLAR_SCRIPT_ID;
    s.src = OPENSOLAR_SRC;
    s.async = true;
    s.onload = () => invoke();
    document.body.appendChild(s);
  } else {
    // If it's already loading, try a short delay
    setTimeout(invoke, 300);
  }
}
